import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "No I-94 drive to Chicago — we handle agency submission",
      "Ideal for NDSU students studying abroad",
      "Perfect for agricultural and ag-tech professionals on international business",
      "Great for Hector International Airport (FAR) flyers",
      "Concordia College and MSUM semester abroad students",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no Chicago drive required",
      "Faster than self-service at Fargo post office",
      "Good for planned international trips from FAR via MSP",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Fargo USPS downtown is primary acceptance facility",
      "No document review — errors cause rejection and restart",
      "In-person clerk appointment required at Cass County facilities",
      "North Dakota mail routing through MSP hub adds extra transit days",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "No passport agency in North Dakota — closest is Chicago, ~580 miles via I-94",
      "8.5+ hour drive to Chicago Regional Passport Agency",
      "NPIC appointment required — no walk-ins at Chicago agency",
      "Life-or-death emergencies only with documentation",
      "Winter blizzards on I-94 can close the highway entirely",
      "Expect to lose a full day driving round-trip",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Fargo"
      headingExtra="ND"
      introText="Fargo travelers — NDSU students preparing for study abroad, agricultural and ag-tech professionals on international business, Concordia College and MSUM students planning overseas semesters, and Hector International Airport flyers connecting through MSP — have several options for getting a passport fast. Here is how they compare, and why most North Dakotans choose a U.S. Department of State registered passport courier rather than making the 580-mile drive to Chicago."
      options={options}
      emergencyDescription="North Dakota has no regional passport agency. The closest is the Chicago Passport Agency at 230 S Dearborn St Suite 380, Chicago IL 60604 — approximately 580 miles, 8.5 hours via I-94. NPIC appointment required. Winter blizzards on I-94 can close the highway entirely, making last-minute trips impossible."
      disclaimerText="*Processing speed depends on eligibility and documentation. North Dakota has no passport agency — the closest is Chicago, IL (~580 miles). Not all applicants qualify for Regional Agency Processing."
    />
  );
}